function o(n, f) {
  if (f(n))
    return n;
  for (const i of n.children) {
    const r = o(i, f);
    if (r)
      return r;
  }
}
export {
  o as DeepFindRgObject
};
//# sourceMappingURL=index3.js.map
